import { render, staticRenderFns } from "./TaskScheduler.vue?vue&type=template&id=6f122d14&scoped=true&"
import script from "./TaskScheduler.vue?vue&type=script&lang=ts&"
export * from "./TaskScheduler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f122d14",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f122d14')) {
      api.createRecord('6f122d14', component.options)
    } else {
      api.reload('6f122d14', component.options)
    }
    module.hot.accept("./TaskScheduler.vue?vue&type=template&id=6f122d14&scoped=true&", function () {
      api.rerender('6f122d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/TaskScheduler.vue"
export default component.exports